import './Clinic.css';
import Navbar from '../Navbar/Navbar';
import '../../assets/css/style.css';
// Consider replacing these images with ones relevant to ICU/Surgical Care if available
import sicuBg1 from './SICU.png'; // Kept original paths, rename/replace images as needed
import sicuBg2 from '../../assets/img/clinic//2.png'; // Kept original paths, rename/replace images as needed
import { useState, useEffect } from 'react';
import hitakrilogo from '../../assets/img/hitakrilogo.png';


const SICU = () => { // Changed component name
     const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
          setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2);
        }, 4000);

        return () => clearInterval(interval);
      }, []);

    // Use the imported images - update these if you have SICU-specific visuals
    const images = [sicuBg1, sicuBg2]; // Used renamed variables for clarity
     const backgroundImage = images[currentImageIndex];

    return (
        <>
        <div className="main-wrapper">
            <header className="header">
                <Navbar />
            </header>

            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/clinic-and-specialities">Our Specialized Medical Departments</a></li>
                                    {/* Updated Breadcrumb */}
                                    <li className="breadcrumb-item active" aria-current="page">SICU (Surgical Intensive Care Unit)</li>
                                </ol>
                            </nav>
                            {/* Updated Title */}
                            <h2 className="breadcrumb-title">SICU (Surgical Intensive Care Unit)</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Breadcrumb */}

            <div className="content">
              {/* Full-Width Background with Minimal Text - Kept urology-header class as requested */}
                           <div className="urology-header" style={{ backgroundImage: `url(${backgroundImage})` }}>
                                <div className="urology-overlay">
                                    <div className="urology-header-content">
                                    <p>
                                       <br />
                                         {/* Updated Header Text */}
                                         <strong>Surgical Intensive Care Unit (SICU) at Hitkari Hospital</strong>
                                          </p>

                                    </div>
                                </div>
                            </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">

                             <div className="terms-content">
                                <div className="terms-text">
                                     {/* Updated Content: Introduction */}
                                     <h3>Surgical Intensive Care Unit (SICU) at Hitkari Hospital</h3>
                                       <p>The Surgical Intensive Care Unit (SICU) at Hitkari Hospital provides specialized, high-level care for patients recovering from major or complex surgical procedures who require intensive monitoring and support. Our dedicated unit is equipped with advanced life-support technology and staffed by a highly skilled multidisciplinary team focused on managing critically ill surgical patients. We prioritize patient safety, optimal recovery, and comprehensive care throughout the critical post-operative phase.</p>
                                </div>
                                <div className="terms-text">
                                    {/* Updated Content: Patient Population */}
                                    <h3>Patients Cared For in the SICU</h3>
                                    <h4>Our SICU team manages patients requiring intensive care after various surgical interventions, including:</h4>
                                    <ul>
                                        <li>Major Abdominal Surgeries: Such as complex bowel resections, pancreatic surgery, or liver procedures.</li>
                                        <li>Complex Orthopedic Surgeries: Including major trauma repairs or extensive joint replacements in high-risk patients.</li>
                                        <li>Neurosurgical Procedures: Post-operative care following brain or spinal surgery.</li>
                                        <li>Major Vascular Surgeries: Patients recovering from aortic aneurysm repair or other significant vascular operations.</li>
                                        <li>Trauma Patients: Individuals requiring surgical intervention and intensive monitoring after severe injuries.</li>
                                        <li>Patients with Post-operative Complications: Managing complications like bleeding, infection (sepsis), or respiratory failure after surgery.</li>
                                    </ul>
                                </div>
                                 <div className="terms-text">
                                       {/* Updated Content: Core Services */}
                                       <h4>Core Services Provided in the SICU</h4>
                                        <ul>
                                            <li>Advanced Hemodynamic Monitoring: Continuous tracking of blood pressure, heart function, and fluid status using invasive and non-invasive techniques.</li>
                                            <li>Mechanical Ventilation Support: Management of patients requiring ventilators to assist breathing after extensive surgery or due to respiratory compromise.</li>
                                            <li>Post-operative Pain Management: Utilizing multimodal approaches, including intravenous medications and regional anesthesia techniques (like epidurals), for effective pain control.</li>
                                            <li>Nutritional Support: Providing specialized enteral or parenteral nutrition for patients unable to eat normally.</li>
                                            <li>Renal Replacement Therapy: Access to dialysis (including continuous therapies like CRRT) for patients experiencing kidney failure.</li>
                                            <li>Wound Care Management: Specialized care for complex surgical wounds to promote healing and prevent infection.</li>
                                        </ul>
                                </div>
                                 <div className="terms-text">
                                      {/* Updated Content: Technology */}
                                      <h4>Advanced Monitoring and Technology</h4>
                                      <ul>
                                            <li>Sophisticated Patient Monitors: Continuous EKG, pulse oximetry, respiratory rate, temperature, and invasive pressure monitoring.</li>
                                            <li>Modern Ventilators: Offering various modes of respiratory support tailored to individual patient needs.</li>
                                            <li>Infusion Pumps: Precise delivery systems for medications, fluids, and nutrition.</li>
                                            <li>Bedside Point-of-Care Testing: Rapid diagnostic testing (e.g., blood gases) available within the unit for timely clinical decisions.</li>
                                            <li>Access to Imaging: Coordination for portable X-rays and ultrasounds, and transport for CT or MRI scans when necessary.</li>
                                        </ul>
                                 </div>
                                   <div className="terms-text">
                                       {/* Updated Content: Multidisciplinary Team */}
                                       <h4>Our Expert SICU Team</h4>
                                        <ul>
                                            <li>Intensivists (Critical Care Physicians): Doctors specialized in managing critically ill patients, overseeing overall care in the SICU.</li>
                                            <li>Critical Care Nurses: Highly trained nurses providing continuous monitoring, administering treatments, and offering direct patient care 24/7.</li>
                                            <li>Surgeons: Close collaboration with the primary surgical team responsible for the patient's operation.</li>
                                            <li>Respiratory Therapists: Experts in managing ventilators and providing respiratory treatments.</li>
                                            <li>Pharmacists: Assisting with complex medication management and ensuring drug safety.</li>
                                            <li>Physical and Occupational Therapists: Initiating early mobilization and rehabilitation as appropriate.</li>
                                        </ul>
                                </div>
                                 {/* Removed the 6th section to keep similar structure (5 specific + intro + conclusion) */}
                                  <div className="terms-text">
                                      {/* Updated Content: Why Choose */}
                                    <h3>Why Choose the SICU at Hitkari Hospital?</h3>
                                      <ul>
                                           <li>Specialized Post-Surgical Critical Care: Focused expertise in managing the unique challenges of critically ill surgical patients.</li>
                                           <li>Experienced Multidisciplinary Team: Collaboration between intensivists, surgeons, critical care nurses, and therapists.</li>
                                            <li>Advanced Life Support Capabilities: Equipped with modern ventilators, monitoring systems, and therapeutic technologies.</li>
                                            <li>Focus on Patient Safety: Strict protocols for infection control, medication safety, and prevention of ICU-related complications.</li>
                                           <li>Continuity of Care: Seamless transition from the operating room to the SICU, with coordinated care throughout the recovery process.</li>
                                           <li>Commitment to Recovery: Aiming not just for survival, but for the best possible functional recovery after major surgery.</li>
                                      </ul>
                                </div>
                                 <div className="terms-text">
                                    {/* Updated Content: Conclusion */}
                                    <p>The Surgical Intensive Care Unit (SICU) at Hitkari Hospital provides a critical link in the care pathway for patients undergoing major surgery. Our dedicated team utilizes advanced technology and specialized expertise to ensure vigilant monitoring, prompt intervention, and comprehensive support, facilitating the safest and most effective recovery possible for our critically ill surgical patients.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer className="footer">
            {/* Footer Top */}
            <div className="footer-top">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-about">
                                <div className="footer-logo">
                                    <img src={hitakrilogo} alt="Hitkari Hospital Logo" className="footer-logo-img" style={{ backgroundColor: '#4b8cd681' }} />
                                </div>
                                <div className="footer-about-content">
                                    <p>Your health is our priority. Combining advanced care with a personal touch, our expert team is dedicated to supporting your journey to better health.</p>
                                    <div className="social-icon">
                                        <ul>
                                            <li><a href="https://www.facebook.com/p/Hitkari-Hospital-100063931666732/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                            <li><a href="https://www.instagram.com/hitkarihospital/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title">For Patients</h2>
                                <ul>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Search for Doctors</a></li>
                                    <li><a href="/privacypolicy"><i className="fas fa-angle-double-right"></i> Privacy-Policy</a></li>
                                    <li><a href="/terms"><i className="fas fa-angle-double-right"></i> Terms-Conditions</a></li>
                                    <li><a href="/booking"><i className="fas fa-angle-double-right"></i> Booking</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Patient Dashboard</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title"
                                >
                                    For Patients
                                </h2>
                                <ul>
                                    <li><a href="/appointments"><i className="fas fa-angle-double-right"></i> Appointments</a></li>
                                    <li><a href="/gallery"><i className="fas fa-angle-double-right"></i> Gallery</a></li>
                                    <li><a href="/services"><i className="fas fa-angle-double-right"></i> Services</a></li>
                                    <li><a href="/"><i className="fas fa-angle-double-right"></i> Doctor Dashboard</a></li>
                                    <li><a href="/blogs"><i className="fas fa-angle-double-right"></i> Blogs</a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-contact">
                                <h2 className="footer-title">Contact Us</h2>
                                <div className="footer-contact-info" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                    <div className="footer-address" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <a href="https://www.google.com/maps?q=NEAR+MTM+SCHOOL,+BALOTRA" target="_blank" rel="noopener noreferrer" style={{ display: 'flex', textDecoration: 'none', color: 'inherit', alignItems: 'flex-start' }}>
                                            <i className="fas fa-map-marker-alt" style={{ marginRight: '5px' }}></i>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <span>Neelam Cinema Ke Pass, BALOTRA,</span>
                                                <span>DISTT.- BARMER ( RAJASTHAN ),</span>
                                                <span>PIN – 344022</span>
                                            </div>
                                        </a>
                                    </div>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="tel:02988223100" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit',marginTop:'18px' }}>
                                            <i className="fas fa fa-phone" style={{ marginRight: '5px' }}></i>
                                            02988-223100
                                        </a>
                                    </p>
                                    <p style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
                                        <a href="mailto:hitkarihospitalblt2015@gmail.com" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', marginTop:'18px' }}>
                                            <i className="fas fa-envelope" style={{ marginRight: '5px' }}></i>
                                            hitkarihospitalblt2015@gmail.com
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container-fluid">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="copyright-text">
                                    <p className="mb-0">
                                        <a href="/" style={{ color: 'white', textDecoration: 'none' }}>@ Copyright Hitkari Hospital, All rights reserved.</a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="copyright-menu">
                                    <ul className="policy-menu">
                                        <li><a href="https://dheersoftwaresolutions.com/" style={{ color: 'white', textDecoration: 'underline', marginRight:'132px' }} target="_blank" rel="noopener noreferrer">Developed By ,Dheer Software Solutions</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        </>
    );
};

export default SICU; // Make sure to export the correct component name